import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { ILeadGroup, LeadGroup } from "@/models/lead-group.entity";

export const LeadGroupDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<ILeadGroup, ""> {
  getIdentifier(entity: ILeadGroup): string {
    return (entity as ILeadGroup).id;
  }

  mapEntity(entity: ILeadGroup): ILeadGroup {
    return new LeadGroup(entity);
  }
})();
